import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppointmentModel } from 'projects/core/src/lib/models/appointment.model';
import { AppointmentCalendarType, AppointmentDayEvent, AppointmentDayEventType } from '../appointment-calendar/appointment-calendar.component';

@Component({
  selector: 'app-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrls: ['./appointment-list.component.scss']
})
export class AppointmentListComponent implements OnInit {

  @Input() type: AppointmentCalendarType = AppointmentCalendarType.Dates;
  @Input() days: Array<AppointmentModel> = [];
  @Input() locations: Array<LocationModel> = [];
  @Input() inEdit: boolean;

  @Output() onDayChange = new EventEmitter<AppointmentDayEventType>();

  public AppointmentCalendarType = AppointmentCalendarType;

  constructor() { }

  ngOnInit(): void {
  }

  public onDeleteDay(day: AppointmentModel): void {
    if (this.inEdit === true) {
      this.onDayChange.emit({
        day,
        event: AppointmentDayEvent.Delete,
      });
    }
  }

}
